import React from 'react';
import { AlertColor } from '@mui/material';
import { useToast, ToastProvider } from 'context/ToastContext';
import { createRoot } from 'react-dom/client';

let toastFunction: ((message: string, type?: AlertColor, duration?: number) => void) | null = null;

export function initToast() {
    const root = createRoot(document.createElement('div'));
    root.render(
        <ToastProvider>
            <ToastInjector />
        </ToastProvider>,
    );
}

function ToastInjector() {
    const toast = useToast();
    toastFunction = toast;
    return null;
}

export const toast = (message: string, type?: AlertColor, duration?: number) => {
    if (!toastFunction) throw new Error('Toast not initialized. Call initToast() first.');
    toastFunction(message, type, duration);
};
